import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MillionPipe } from '../million.pipe';
import { NumberFormatterPipe } from './number-formatter.pipe';



@NgModule({
  declarations: [
    MillionPipe,
    NumberFormatterPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MillionPipe,
  ]
})
export class SharedModule { }
